module.exports = __webpack_public_path__ + "static/media/location-icon-alta-severity-2.0eee6fec.png";